export const TOGGLE_VACANCY_MODAL = "TOGGLE_VACANCY_MODAL";

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";

export const TOGGLE_FORMS_MODAL = "TOGGLE_FORMS_MODAL";

export const SET_CLIENT_WIDTH = 'SET_CLIENT_WIDTH';

export const END_ANIMATION = 'END_ANIMATION';


// WEBPACK FOOTER //
// ./src/constants.js